import {
    SET_DISPOSITION_CHOICE, SET_DISPOSITION_SUB_CHOICE,
} from "./DispositionChoiceType";

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_DISPOSITION_CHOICE:
            return {
                ...state,
                dispositionChoiceList: action.choiceList,
            };
        case SET_DISPOSITION_SUB_CHOICE:
            return {
                ...state,
                dispositionSubChoiceList: action.subChoiceList,
            };
        default:
            return state;
    }
};

export default reducer;
